import {data_pforten} from '../../../assets/images/pforten/data_pforten';

const initialeStates = {
    data: data_pforten
}

const pfortenReducer = (states = initialeStates, action) => {
    const copyOfState = {...states};

    switch (action.type) {

        //update modell
        case 'UPDATEMODELLPFORTE':
            let modell_index = action.ev.index;
            let modell_img = action.ev.img;
            let modell_titel = action.ev.titel;
            let modell_form = action.ev.form;

            copyOfState.data.modell[0].index = modell_index;
            copyOfState.data.modell[0].img = modell_img;
            copyOfState.data.modell[0].titel = modell_titel;
            copyOfState.data.modell[0].form = modell_form;
        return copyOfState;

        //update muster
        case 'UPDATEMUSTERPFORTE':
            let muster = action.ev;
            copyOfState.data.modell[0].muster = muster;
        return copyOfState;

        //update tab index
        case 'UPDATETABINDEXPFORTE':
            let tab_index = action.ev;
            copyOfState.data.tabs[0].tab_index = tab_index;
        return copyOfState;

        //update steps
        case 'UPDATESTEPSPFORTE':
            let step_index = action.ev;
            let steps = copyOfState.data.steps[0];
            let visited_steps = copyOfState.data.steps[1].visited;
            let step_icons = document.querySelectorAll(".MuiStepIcon-root");

            copyOfState.data.steps[0][step_index] = true;
            copyOfState.data.steps[1].visited[step_index] = step_index;

            steps.forEach((elem, index) => {
                 if(elem === true) {
                    step_icons[index].classList.add('MuiStepIcon-active');
                 } else {
                    step_icons[index].classList.remove('MuiStepIcon-active');
                 }
            })

            copyOfState.data.steps[1].active_steps = visited_steps;
        return copyOfState;

        //update all visited steps
        case 'UPDATEALLVISITEDSTEPSPFORTE':
            copyOfState.data.allVisitedSteps = true;
        return copyOfState;

        //update height
        case 'UPDATEHEIGHTPFORTE':
            let height = action.ev;
            copyOfState.data.dimensions[0].height = height;
        return copyOfState;

        //update width
        case 'UPDATEWIDTHPFORTE':
            let width = action.ev;
            copyOfState.data.dimensions[0].width = width;
        return copyOfState;

        //update kind of color
        case 'SELECTKINDOFCOLORPFORTE':
            let kind_of_color = action.ev;
            copyOfState.data.colors[0].kind_of_color = kind_of_color;
        return copyOfState;

        //update color
        case 'SELECTCOLOROFPFORTE':
            let color = action.ev.color;
            let color_index = action.ev.index;
            copyOfState.data.colors[0].color_index = color_index;
            copyOfState.data.colors[0].color = color;
            copyOfState.data.colors[0].wish_color = '';
        return copyOfState;

        //update wish color
        case 'SELECTWISHCOLORPFORTE':
            let wish_color = action.ev;
            copyOfState.data.colors[0].wish_color = wish_color;
        return copyOfState;

        //update Zaunspitze
        case 'UPDATEZAUNSPITZENPFORTE':
            let spitze = action.ev.titel;
            let spitze_index = action.ev.index;
            copyOfState.data.spitzen[0].spitze = spitze;
            copyOfState.data.spitzen[0].index = spitze_index;
        return copyOfState;

        //update pfosten
        case 'UPDATEPFOSTENPFORTE':
            let pfosten_ident_index = action.ev.ident_index;
            let pfosten_ident_name = action.ev.ident_name;
            let pfosten_ident_value = action.ev.value;

            if(pfosten_ident_name === 'pfostenwidth') {
                copyOfState.data.pfosten[0].pfosten_width = pfosten_ident_value;
            }
            if(pfosten_ident_index === '0') {
                copyOfState.data.pfosten[0].ispfosten = true;
                copyOfState.data.pfosten[0].iskappen = false;
            }
            else if(pfosten_ident_index === '1') {
                copyOfState.data.pfosten[0].ispfosten = false;
                copyOfState.data.pfosten[0].iskappen = true;
            }
        return copyOfState;

        //update kappen
        case 'UPDATEKAPPENPFORTE':
            let kappe_titel = action.ev.titel;
            let kappe_index = action.ev.index;
            copyOfState.data.pfosten[0].kappe = kappe_titel;
            copyOfState.data.pfosten[0].kappe_index = kappe_index;
        return copyOfState;

        //update direction
        case 'UPDATEDIRECTIONPFORTE':
            let direction = action.ev;
            copyOfState.data.direction = direction;
        return copyOfState;

        //update product to merkliste
        case 'UPDATEPRODUCTTOMERKLISTEPFORTE':
            copyOfState.data.is_merkliste = !copyOfState.data.is_merkliste;
        return copyOfState;

        //update description
        case 'UPDATEDESCRIPTIONPFORTE':
            let description = action.ev;
            copyOfState.data.data_description[0].description = description;
        return copyOfState;

        //select upload file
        case 'SELECTUPLOADDATAPFORTE':
            const fileSize = action.ev.file.size;
            const bytesToMegaBytes = fileSize / (1024 ** 2);
            if (bytesToMegaBytes>5) {
                copyOfState.data.data_description[0].isUploadData = false;
            } else {
                let data_file = action.ev.file;
                copyOfState.data.data_description[0].file = data_file;
                copyOfState.data.data_description[0].isUploadData = true;
            }
        return copyOfState;

        case 'UPDATEEDITPFORTE':
            copyOfState.data.isEdit = !copyOfState.data.isEdit;
        return copyOfState;

        default:
            return copyOfState;
    }

}

export default pfortenReducer;